// base64文件转成file文件
function Base64ToFile(base64, filename) {
  try {
    const arr = base64.split(',')
    console.log('base64 - 1.....', arr)
    const mime = arr[0].match(/:(.*?);/)[1]
    console.log('base64 - 2.....', mime)
    const suffix = mime.split('/')[1]
    console.log('base64 - 3.....', suffix)
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename || +new Date()}.${suffix}`, {
      type: mime
    })
  }
  catch(error) {
    console.log('base64ToFile ....', error)
  }
}

// 图片链接转成base64
function getUrlToBase64Image(url, width, height) {
  return new Promise((resolve) => {
    const image = new Image()
    image.src = url
		image.setAttribute('crossOrigin', 'anonymous')
    image.onload = () => {
      try {
				const finalWidth = width || image.width
				const finalHeight = height || image.height
				const canvas = document.createElement('canvas')
				canvas.width = finalWidth 
				canvas.height = finalHeight
				const ctx = canvas.getContext('2d')
				ctx.drawImage(image, 0, 0, finalWidth, finalHeight)
				const base64 = canvas.toDataURL('image/jpeg')
				resolve(base64)
			}
			catch(error) {
				console.log('toBase64Image........', error)
				resolve('')
			}  
    }
    image.onerror = (error) => {
			console.log('转成base64失败。。。', error)
			resolve('')
		}
  })
}

// 加载图片，获取图片的宽度和高度
async function loadImage(img, type) {
	const obj = {}
	const imageElement = new Image()
	imageElement.src = img
	return new Promise(resolve => {
		imageElement.onload = async () => {
			obj.img = img
			if (imageElement.width > 4999) imageElement.width = 4999
			if (imageElement.height > 19999) imageElement.height = 19999
			// 如果图片必须是1:1的，则需要判断当前的图片宽高比是否相等，
			// 如不相等，则需要把宽高比设置为相等，且转成base64 (因为铺货时图片需要上传到服务器)
			if (type === '1:1') {
				if (imageElement.width !== imageElement.height) {
					const getMaxValue = imageElement.width > imageElement.height ? imageElement.width : imageElement.height
					imageElement.width = imageElement.height = getMaxValue
					obj.img = await getUrlToBase64Image(obj.img, getMaxValue, getMaxValue)
					obj.isUpdate = true
				}
			}
			obj.width = imageElement.width
			obj.height = imageElement.height
			resolve(obj)
		}
		imageElement.onerror = () => {
			obj.img = imageElement
			obj.width = imageElement?.width
			obj.height = imageElement?.height
			console.log('img error.....', imageElement, obj)
			resolve(obj)
		}
	})
}

// 压缩图片，最后得到base64
function getCanvasDataURL(path, obj) {
  return new Promise(resolve => {
    const img = new Image()
    img.src = path
    img.setAttribute("crossOrigin", 'Anonymous')
    img.onload = function () {
      const num = 750
      let w, h
      if (w > h) {
        w = num
        h = this.height / this.width * num
      } 
      else {
        h = num
        w = this.width / this.height * num
      }
      let quality = 0.7 // 默认图片质量为0.7 quality值越小，所绘制出的图像越模糊
      //生成canvas
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const anw = document.createAttribute("width")
      anw.nodeValue = w
      const anh = document.createAttribute("height")
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(this, 0, 0, w, h)
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) quality = obj.quality
      resolve(canvas.toDataURL('image/jpeg', quality))
    }
  })
}

// 根据图片链接得到图片具体的宽度和高度
async function GetFinalImageList(list, type) {
	const newList = []
	try {
		for (let i in list) {
			const obj = await loadImage(list[i], type)
			// 如果不是详情图才去找图片代替
			const obj2 = type !== 'detail' ? (newList[i - 3] || newList[i - 2] || newList[i - 1]) : null
			const imgItem = (obj?.img && obj.width > 1 && obj.height > 1) ? obj : obj2
			// 如果有图片链接并且有宽高则获取 / 否则获取前3前2或者前1的图片
      if (imgItem) newList.push(JSON.parse(JSON.stringify(imgItem)))
      // 剔除掉详情图
      else if (type === '1:1') newList.push({})
		}
	}
	catch(error) {
		console.log(error)
	}
	return newList
}

// 得到最终的base64
async function GetFinalBase64(img, maxSize = 300) {
  img = await getUrlToBase64Image(img)
  if (!img) return img
  const file = await Base64ToFile(img)
  // 如果大于300KB才执行压缩图片
  if (file.size > maxSize * 1024) img = await getCanvasDataURL(img, { quality: 0.7 })
  return img
}

export default {
  GetFinalImageList, GetFinalBase64, Base64ToFile
}